import moment, { Moment } from 'moment';
import { getMomentDate } from '../../../Utils/dates.util';

export default function useHealthDataFilter() {
	const getPrepareFilterData = (
		view: string,
		date: Moment | string,
		dateForm: Moment | string,
		dateTo: Moment | string,
	) => {
		if (view === 'day') {
			const from = moment(date).startOf('day');
			const to = moment(date).endOf('day');
			return { view, from, to };
		}
		if (view === 'week') {
			const from = moment().subtract(1, 'week').startOf('day');
			const to = moment().endOf('day');
			return { view, from, to };
		}
		if (view === 'month') {
			const from = moment().subtract(1, 'month').startOf('day');
			const to = moment().endOf('day');
			return { view, from, to };
		}
		if (view === 'year') {
			const from = moment().subtract(1, 'year').startOf('day');
			const to = moment().endOf('day');
			return { view, from, to };
		}
		if (view === 'custom') {
			const from = getMomentDate(dateForm).startOf('day');
			const to = getMomentDate(dateTo).endOf('day');

			const diff = moment.duration(to.diff(from));
			if (diff.asDays() < 1) {
				return { view: 'day', from, to };
			}
			if (diff.asDays() > 1 && diff.asDays() < 8) {
				return { view: 'week', from, to };
			}
			if (diff.asDays() >= 8) {
				return { view: 'month', from, to };
			}
			if (diff.asDays() > 31) {
				return { view: 'year', from, to };
			}
		}
		const from = moment().startOf('day');
		const to = moment().startOf('day');
		return { view, from, to };
	};

	return { getPrepareFilterData };
}
